<template>
  <validation-observer ref="refFormObserver">
    <b-form>
      <b-row class="mx-0">
        <!-- Transmission live video -->
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$t('vxg_camera.main_transmission')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('vxg_camera.main_transmission')"
              label-for="main_transmission"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.main_transmission"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="mainTransmitionOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="main_transmission"
                @input="handleMainTransmissionChange"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- Transmission recorded video -->
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$t('vxg_camera.live_broadcast')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('vxg_camera.live_broadcast')"
              :label-for="`live_broadcast`"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.live_broadcast"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="liveBroadcastOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="live_broadcast"
                @input="handleLiveBroadcastChange"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <!-- Configuration transmission -->
      <b-row class="mx-0">
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$t('vxg_camera.transmission')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('vxg_camera.transmission')"
              :label-for="`transmission`"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.transmission"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="transmissionOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="transmission"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- Btn Update stream configuration -->
        <!-- <b-col cols="6">
          <b-button
            v-if="itemData.transmission"
            @click="updateStreamConfiguration"
            variant="primary"
            class="align-with-select"
          >
            {{ $t('vxg_camera.update_stream') }}
          </b-button>
        </b-col> -->
      </b-row>
      <b-row class="mx-0">
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$t('vxg_camera.video_encoder')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('vxg_camera.video_encoder')"
              label-for="video_encoder"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.video_encoder"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="videoEncoderOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="video_encoder"
                @input="handleInputChange('video_encoder', $event)"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            name="resolution"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('camera_proxy.resolution')"
              label-for="resolution"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.resolution"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="resolutionOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="resolution"
                @input="handleInputChange('resolution', $event)"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row class="mx-0">
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            name="frame_rate"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('camera_proxy.frame_rate')"
              label-for="frame_rate"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.frame_rate"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="frameRateOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="frame_rate"
                @input="handleInputChange('frame_rate', $event)"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- Add GOP field -->
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            name="gop"
            :rules="gopValidation ? 'required' : ''"
          >
            <b-form-group
              class="text-capitalize"
              label="Gop"
              label-for="gop"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.gop"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="gopOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="gop"
                @input="handleInputChange('gop', $event)"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
          <b-col cols="6">
          <validation-provider
            #default="validationContext"
            name="bitrate"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('vxg_camera.bitrate')"
              label-for="bitrate"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.bitrate"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="bitrateOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="bitrate"
                @input="handleInputChange('bitrate', $event)"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6" v-if="itemData.vbr">
          <validation-provider
            #default="validationContext"
            :name="$t('vxg_camera.vbr_quality')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('vxg_camera.vbr_quality')"
              label-for="vbr_quality"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.vbr_quality"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="vbrQualityOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="vbr_quality"
                @input="handleInputChange('vbr_quality', $event)"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row class="mx-0">
        <b-col cols="6">
          <validation-provider :name="$t('vxg_camera.vbr')" rules="required">
            <b-form-checkbox
              id="vbr"
              v-model="itemData.vbr"
              name="vbr"
              :value="true"
              :unchecked-value="false"
              class="my-1 text-capitalize"
              switch
              @change="handleVbrChange"
            >
              {{ $t("vxg_camera.vbr") }}
            </b-form-checkbox>
          </validation-provider>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
// Resto de las importaciones
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import SelectPaginate from "@/views/components/SelectPaginate.vue";
import { ref, computed, watch, onMounted, isEqual, nextTick } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import store from '@/store';
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    SelectPaginate,
  },
  props: {
    propItemData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    propResData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    propStreamData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isAdd: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18nUtils();
    const toast = useToast();
    const { refFormObserver, getValidationState } = formValidation();

    const itemData = ref({
      ...props.propItemData,
    });
    const recsModeOptions = [
      { value: "off", label: "Off" },
      { value: "on", label: "On" },
      { value: "by_event", label: "By event" },
    ];
    const vbrQualityOptions = ref([]);
    const frameRateOptions = ref([]);

    const resolutionOptions = ref([]);

    const defaultConfig = ref(null);
    const isMainTransmissionChange = ref(false);

    // Main transmission optiones load the live stream available
    const mainTransmitionOptions = ref([]);
    props.propResData.streamAvailable.forEach((_, index) => {
      mainTransmitionOptions.value.push({
        value: index + 1,
        label: _.id_stream
      });
    });

    // Live broadcast optiones load the recording stream available
    const liveBroadcastOptions = ref([]);
    props.propResData.streamAvailable.forEach((_, index) => {
      liveBroadcastOptions.value.push({
        value: index + 1,
        label: _.id_stream
      });
    });

    // Transmission optiones load the stream available for configuration
    const transmissionOptions = ref([]);
    props.propResData.streamAvailable.forEach((_, index) => {
      transmissionOptions.value.push({
        value: index + 1,
        label: _.id_stream
      });
    });

    const videoEncoderOptions = ref([]);
    const bitrateOptions = ref([]);

    const gopOptions = ref([]);

    const gopValidation = ref(true);

    const isInitialLoad = ref(true);

    const isDataModified = ref(false);
    const isInitialSetupComplete = ref(false);

    const isInitialSetup = ref(true);

    const setConfiguration = (config) => {
      if (config) {
        const selectedStreamLabel = config.id_stream;
        const selectedStreamConfig = props.propResData.streamAvailableConfigurations.find(
          cfg => cfg.id_stream === selectedStreamLabel
        );

        const selectedFormatConfig = selectedStreamConfig?.configuration.find(
          cfg => cfg.format === config.format
        );

        if (selectedFormatConfig) {
          frameRateOptions.value = Array.from(
            { length: selectedFormatConfig.max_fps },
            (_, index) => ({
              value: index + 1,
              label: (index + 1).toString()
            })
          );

          resolutionOptions.value = selectedFormatConfig.resolutions.map(resolution => ({
            value: resolution,
            label: `${resolution.width}x${resolution.height}`
          }));

          const minBitrate = selectedFormatConfig.min_bitrate;
          const maxBitrate = selectedFormatConfig.max_bitrate;
          const step = 64;

          bitrateOptions.value = [];
          for (let i = minBitrate; i <= maxBitrate; i += step) {
            bitrateOptions.value.push({
              value: i,
              label: `${i} Kbps`
            });
          }

          if (selectedFormatConfig.vbr === 1) {
            const minQuality = selectedFormatConfig.min_vbr_quality;
            const maxQuality = selectedFormatConfig.max_vbr_quality;

            vbrQualityOptions.value = Array.from(
              { length: maxQuality - minQuality + 1 },
              (_, index) => ({
                value: minQuality + index,
                label: (minQuality + index).toString()
              })
            );
          }

          const minGop = selectedFormatConfig.min_gop;
          const maxGop = selectedFormatConfig.max_gop;

          if(minGop === maxGop && minGop === 0) {
            gopValidation.value = false;
          }
          gopOptions.value = [];
          for (let i = minGop; i <= maxGop; i++) {
            gopOptions.value.push({
              value: i,
              label: i.toString()
            });
          }

          // Modified resolution handling
          const resolutionValue = config.resolution ? {
            value: config.resolution, // Store the full resolution object
            label: `${config.resolution.width}x${config.resolution.height}`
          } : null;

          // Set the values with proper resolution object
          itemData.value = {
            ...itemData.value,
            video_encoder: config.format || '',
            resolution: resolutionValue?.value || '',
            frame_rate: config.fps || '',
            bitrate: config.bitrate || config.vbr_bitrate || 64,
            vbr: config.vbr === 1,
            vbr_quality: config.vbr_quality || '0',
            gop: config.gop || ''
          };
        }
      } else {
        // Reset all options and values
        frameRateOptions.value = [];
        resolutionOptions.value = [];
        bitrateOptions.value = [];
        vbrQualityOptions.value = [];
        gopOptions.value = [];

        itemData.value = {
          ...itemData.value,
          video_encoder: '',
          resolution: '',
          frame_rate: '',
          vbr_quality: '',
          vbr: false,
          bitrate: '',
          gop: '',
        };
      }
    };

    // Modify the watch handler for transmission
    watch(() => itemData.value.transmission, (newValue) => {
      if (newValue) {
        isMainTransmissionChange.value = true;
        const selectedLabel = mainTransmitionOptions.value.find(option => option.value === newValue)?.label;
        const selectedConfig = props.propResData.streamAvailableConfigurations.find(config => config.id_stream === selectedLabel);
        const getConfig = props.propResData.streamAvailable.find(config => config.id_stream === selectedLabel);
        defaultConfig.value = getConfig;

        // Update transmissionLabel when transmission changes
        itemData.value.transmissionLabel = selectedLabel;

        const formats = selectedConfig ? selectedConfig.configuration.map(cfg => ({
          value: cfg.format,
          label: cfg.format
        })) : [];

        videoEncoderOptions.value = formats;
        setConfiguration(getConfig);

        // Emit the updated itemData
        emit('update:itemData', itemData.value);
      }
    });

    const validateStep = () => {
      return refFormObserver.value.validate();
    };

    // Handle the change of the main transmission
    const handleMainTransmissionChange = (value, isInitial = false) => {
      const label = mainTransmitionOptions.value.find(option => option.value === value)?.label;
      const selectedStream = props.propResData.streamAvailable.find(stream => stream.id_stream === label);
      if (selectedStream) {
        itemData.value.live_stream = selectedStream.media_stream;
        itemData.value.live_stream_id = selectedStream.id;
      }
    };

    // Handle the change of the live broadcast
    const handleLiveBroadcastChange = (value) => {
      const label = liveBroadcastOptions.value.find(option => option.value === value)?.label;
      const selectedStream = props.propResData.streamAvailable.find(stream => stream.id_stream === label);
      if (selectedStream) {
        // Update all related values
        itemData.value = {
          ...itemData.value,
          recording_stream: selectedStream.media_stream,
          recording_stream_id: selectedStream.id,
          live_broadcast: value,
          stream_recording: selectedStream.id
        };

      }
    };

    const setInitialStreamValues = async () => {
      if (props.propStreamData.stream_live) {
        const streamConfig = props.propResData.streamAvailable.find(
          config => Number(config.id) === Number(props.propStreamData.stream_live)
        );

        if (streamConfig) {
          const mainTransIndex = props.propResData.streamAvailable.findIndex(
            stream => stream.id_stream === streamConfig.id_stream
          );

          if (mainTransIndex !== -1) {
            itemData.value.main_transmission = mainTransIndex + 1;
            itemData.value.transmission = mainTransIndex + 1;
            itemData.value.transmissionLabel = streamConfig.id_stream;
            handleMainTransmissionChange(mainTransIndex + 1, true);

            const selectedLabel = streamConfig.id_stream;
            const selectedConfig = props.propResData.streamAvailableConfigurations.find(
              config => config.id_stream === selectedLabel
            );

            if (selectedConfig) {
              videoEncoderOptions.value = selectedConfig.configuration.map(cfg => ({
                value: cfg.format,
                label: cfg.format
              }));

              itemData.value.video_encoder = streamConfig.format;
            }

            setConfiguration(streamConfig);
          }
        }
      }

      if (props.propStreamData.stream_recording) {
        const recordingConfig = props.propResData.streamAvailable.find(
          config => Number(config.id) === Number(props.propStreamData.stream_recording)
        );
        if (recordingConfig) {
          const recordingIndex = props.propResData.streamAvailable.findIndex(
            stream => stream.id_stream === recordingConfig.id_stream
          );
          if (recordingIndex !== -1) {
            itemData.value.live_broadcast = recordingIndex + 1;
            handleLiveBroadcastChange(recordingIndex + 1);
          }
        }
      }

      // Mark initial setup as complete
      await nextTick();
      isInitialSetup.value = false;
    };

    // Call setInitialStreamValues when component mounts
    onMounted(() => {
      if (props.propItemData) {
        setInitialStreamValues();
      }
    });


    // Modify handleInputChange to check for actual changes
    const handleInputChange = (field, value, isInitial = false) => {
      // Only mark as modified if it's not initial load and value actually changed
      if (!isInitial && isInitialSetupComplete.value && value !== props.propItemData[field]) {
        isDataModified.value = true;
        emit('update:itemData', itemData.value);
      }

      itemData.value[field] = value;
    };

    // Replace all individual watchers with a single watcher
    const watchedFields = [
      'frame_rate',
      'resolution',
      'bitrate',
      'gop',
      'vbr',
      'vbr_quality',
      'main_transmission',
      'live_broadcast',
    ];

    watchedFields.forEach(field => {
      watch(
        () => itemData.value[field],
        (newValue) => {
          if (newValue) {
            emit('update:itemData', itemData.value);
          }
        }
      );
    });

        // Watch video_encoder to load the configuration of the stream with video_encoder settings
    watch(() => itemData.value.video_encoder, (newValue) => {
      if (newValue && !isInitialSetup.value) {
        const selectedStreamLabel = mainTransmitionOptions.value.find(
          option => option.value === itemData.value.transmission
        )?.label;

        const selectedStreamConfig = props.propResData.streamAvailableConfigurations.find(
          config => config.id_stream === selectedStreamLabel
        );

        const selectedFormatConfig = selectedStreamConfig?.configuration.find(
          cfg => cfg.format === newValue
        );

        if (selectedFormatConfig) {
          const existingConfig = props.propResData.streamAvailable.find(
            config => config.id_stream === selectedStreamLabel && config.format === newValue
          );

          if (existingConfig) {
            // If the selected configuration exists, load its values
            setConfiguration(existingConfig);
          } else {
            const configObject = {
              id_stream: selectedStreamLabel,
              format: newValue,
              ...selectedFormatConfig,
              resolution: selectedFormatConfig.resolutions[0],
              fps: selectedFormatConfig.max_fps > 0 ? 1 : 0,
              vbr: 0,
              vbr_quality: selectedFormatConfig.min_vbr_quality || 0,
              bitrate: 64,
              gop: selectedFormatConfig.min_gop
            };
            setConfiguration(configObject);
          }
        }
      }
    });

    const handleVbrChange = (value) => {
      itemData.value.vbr = value;
      emit('update:itemData', itemData.value);
    };

    return {
      t,
      refFormObserver,
      getValidationState,
      validateStep,
      itemData,
      recsModeOptions,
      vbrQualityOptions,
      frameRateOptions,
      resolutionOptions,
      mainTransmitionOptions,
      liveBroadcastOptions,
      transmissionOptions,
      videoEncoderOptions,
      bitrateOptions,
      setConfiguration,
      // updateStreamConfiguration,
      handleMainTransmissionChange,
      handleLiveBroadcastChange,
      gopOptions,
      handleInputChange,
      handleVbrChange,
      gopValidation
    };
  },
};
</script>
<style scoped>
.mx-0 {
  display: flex;
  align-items: center;
}

</style>
